<template>
 <div class="film_wrapper">
    <film-header class="app_header" />
    <el-scrollbar class="film_main" ref="filmMain">
      <film-main />
      <ys-nameplate></ys-nameplate>
      <ys-footer></ys-footer>
    </el-scrollbar>
    
  </div>
  
</template>

<script>
  import filmHeader  from './components/filmHeader'
  import ysNameplate from '@/components/ys-nameplate'
  import filmMain from './components/filmMain'
  import ysFooter from '@/components/ys-footer'
  export default {
    name: 'filmIndex',
    components: {
      filmHeader,
      filmMain,
      ysNameplate,
      ysFooter
    },
    data() {
      return {
        

      }
    },
    
    mounted() {
      
      this.$bus.$on('filmMainScrollTo',()=>{
          setTimeout(()=>{
            if(this.$refs.filmMain&&this.$refs.filmMain.wrap){
              this.$refs.filmMain.wrap.scrollTop  = 400;
            }
          },500)
        })
        this.$bus.$on('scrollTop', () => {
          if(this.$refs.filmMain&&this.$refs.filmMain.wrap){
            this.$refs.filmMain.wrap.scrollTop = 0
          }
        })
    },
    methods: {
      /**
       * 初始化
       * */
      
    }
  }
</script>

<style lang="scss" scoped>
@import '@/sass/film.scss';
.film {
    &_wrapper {
      height: 100%;
      display: flex;
      flex-direction: column;
      min-width: 1600px;
    }

    &_header {
      flex-shrink: 0;
      position: relative;
      z-index: 30;
    }

    &_main {
      flex: 1 0 0;

      /* 设置滚动条的样式 */
      &::-webkit-scrollbar {
        width: 12px;
        height: 12px;
        border-radius: 12px;
        background-color: rgba(0, 0, 0, 0.1);
      }

      // /* 滚动条滑块 */
      &::-webkit-scrollbar-thumb {
        width: 6px;
        border-radius: 12px;
        background: rgba(0, 0, 0, 0.2);
      }

      ::v-deep {
        .el-scrollbar__wrap {
          overflow-x: hidden;
        }

        .el-scrollbar__bar.is-vertical {
          width: 12px;
        }

        .el-scrollbar__thumb {
          background-color: rgba(144, 147, 153, .6);
        }
      }
    }
  }
</style>